import ES from './es';
import EN from './en';

const email = {
    ES,
    EN
};

export default email;
